import React from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmDialog = ({ 
  open, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel', 
  rtl = false,
  isRecurring = false,
  onConfirmAll = null
}) => {
  const { t } = useTranslation();
  
  if (!open) return null;
  
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-md flex items-center justify-center z-[100]">
      <div className={`bg-white/95 dark:bg-neutral-900/95 backdrop-blur-xl rounded-2xl border border-white/20 dark:border-neutral-700/50 p-8 max-w-md w-full animate-fade-in shadow-[0_8px_32px_0_rgba(31,38,135,0.37)] ${rtl ? 'text-right' : ''}`}>
        <div className="mb-6 text-lg font-semibold text-neutral-800 dark:text-white">{message}</div>
        
        {isRecurring && onConfirmAll && (
          <div className="mb-6 p-4 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-xl">
            <p className="text-sm text-orange-700 dark:text-orange-400 font-semibold mb-2">
              {t('ownerdashboard.recurringWarningTitle')}
            </p>
            <p className="text-xs text-orange-600 dark:text-orange-300">
              {t('ownerdashboard.recurringWarningMessage')}
            </p>
          </div>
        )}
        
        <div className={`flex gap-3 ${isRecurring ? 'flex-col' : 'justify-end'}`}>
          {isRecurring && onConfirmAll && (
            <button
              onClick={onConfirmAll}
              className="w-full px-5 py-3 rounded-xl bg-red-600 text-white font-semibold hover:bg-red-700 transition shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            >
              <span>🗑️</span>
              <span>{t('ownerdashboard.deleteAllInstances')}</span>
            </button>
          )}
          
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-5 py-2 rounded-xl border-2 border-neutral-300 dark:border-neutral-600 text-neutral-700 dark:text-neutral-300 font-semibold hover:bg-neutral-50 dark:hover:bg-neutral-700 transition"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-5 py-2 rounded-xl bg-primary text-white font-semibold hover:bg-primary-dark transition shadow-lg hover:shadow-xl"
            >
              {isRecurring ? t('ownerdashboard.deleteThisOnly') : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;